/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Error_Code_RequiredInputs */

const de_auth_mfa_error_code_required = /** @type {(inputs: Auth_Mfa_Error_Code_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie den vollständigen Code ein.`)
};

/** @type {(inputs: Auth_Mfa_Error_Code_RequiredInputs) => LocalizedString} */
const en_auth_mfa_error_code_required = de_auth_mfa_error_code_required;

/**

* @param {Auth_Mfa_Error_Code_RequiredInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_error_code_required = /** @type {((inputs?: Auth_Mfa_Error_Code_RequiredInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Error_Code_RequiredInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_error_code_required(inputs)
	return en_auth_mfa_error_code_required(inputs)
});